import React from "preact";

function TemplateIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="45"
      height="44"
      fill="none"
      viewBox="0 0 45 44"
    >
      <rect width="44" height="44" x="0.5" fill="none" rx="22"></rect>
      <path
        fill="#333"
        d="M29.479 11.306h-13.9a.915.915 0 00-.916.916v19.363c0 .505.41.915.915.915h13.9c.506 0 .916-.41.916-.915V12.222a.915.915 0 00-.915-.916zm-.916 19.364h-12.06V13.145h12.05V30.67h.01z"
      ></path>
      <path
        fill="#333"
        d="M24.788 16.94l-.172.296.315.153-.029.343h.353l.114.334.315-.134.238.248.239-.248.314.134.115-.334h.343l-.02-.343.306-.153-.162-.305.22-.257-.277-.21.105-.333-.334-.077-.048-.343-.343.067-.172-.296-.286.19-.286-.19-.18.296-.344-.067-.038.343-.334.086.096.324-.277.22.229.257zm-6.683.668h4.747a.543.543 0 100-1.087h-4.747a.543.543 0 100 1.087zm8.599 7.027H23.94a.543.543 0 100 1.086h2.765a.543.543 0 100-1.086zM23.94 21.67h2.764a.543.543 0 100-1.087H23.94a.543.543 0 100 1.087zm-2.308-1.097h-3.527a.543.543 0 100 1.087h3.527a.543.543 0 100-1.087zm.115 3.928h-3.538a.429.429 0 00-.428.43v2.964c0 .237.192.43.428.43h3.538a.429.429 0 00.429-.43V24.93a.429.429 0 00-.43-.429z"
      ></path>
    </svg>
  );
}

export default TemplateIcon;
